import { render, staticRenderFns } from "./SsoPaymentsView.vue?vue&type=template&id=03c2788e&scoped=true"
import script from "./SsoPaymentsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SsoPaymentsView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SsoPaymentsView.vue?vue&type=style&index=0&id=03c2788e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c2788e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03c2788e')) {
      api.createRecord('03c2788e', component.options)
    } else {
      api.reload('03c2788e', component.options)
    }
    module.hot.accept("./SsoPaymentsView.vue?vue&type=template&id=03c2788e&scoped=true", function () {
      api.rerender('03c2788e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/anotherApplications/SsoPaymentsView.vue"
export default component.exports